import React from 'react';

import s from './styles.module.scss';
import { fieldTypeComponents } from './field-type-components';

import type { FormikProps } from 'formik';
import type { TFormItem, FieldValueMap, TFieldProps } from '../types';

function renderField<K extends keyof FieldValueMap>(
  type: K,
  props: TFieldProps<K>,
) {
  return fieldTypeComponents[type](props);
}

interface FormItemProps<TValues, TItem extends TFormItem> {
  item: TItem;
  formik: FormikProps<TValues>;
}

const FormItem = <
  TValues extends Record<string, any>,
  TItem extends TFormItem & { name: keyof TValues },
>({
  item,
  formik,
}: FormItemProps<TValues, TItem>) => {
  const { values, setFieldValue } = formik;

  if (item.type === 'info') {
    return <div className={s.wrapper}>{item.html}</div>;
  }

  const value = values[item.name];
  const isTitleValid = React.isValidElement(item.title);

  const onChange = (val: FieldValueMap[typeof item.type]) => {
    const key = item.name;
    setFieldValue(key, val);
  };

  return (
    <>
      <div className={s.wrapper}>
        {isTitleValid && (
          <div className={s['title-wrapper']}>
            {item.title} {item.required && <span>*</span>}
          </div>
        )}
        {item.description && (
          <div className={s['description-wrapper']}>
            <p>{item.description}</p>
          </div>
        )}
        {renderField(item.type, {
          item,
          value,
          onChange,
          formik,
        })}
      </div>
      {item?.items?.map((i) => (
        <FormItem item={i} key={i.key} formik={formik} />
      ))}
    </>
  );
};
export default FormItem;
